import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          本周必看推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          编辑团队精选，每周更新最值得看的高分好片
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
                  {item.category}
                </span>
                <h3 className="text-lg font-semibold text-foreground-900 mt-3 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}